export default __webpack_public_path__ + "static/grass-1000-8d91e9319fd90cc8b624ca353b7606c9.jpg";